import Actions from 'actions';

const initialState = Object.freeze({});

function show(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_USER_REQUEST:
      return initialState;
    case Actions.FETCH_USER_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_USER_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default show;
